import React, { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { getResponsiveSize } from '../../utils';
import AccordionComponent from '../UI/AccordionExpandIcon/AccordionComponent';
import { PractitionerMediaPreviewHost } from '../PractitionerMediaPreviewPlayer/PractitionerMediaPreviewReversePortal';
import { ControlPanelFooterSX } from './styles';
interface ContainerProps {
  sendThemeCommand: (value: boolean) => void;
  isGameLoading: boolean;
  isCallActive: boolean;
  mediaPreviewPortalNode: HTMLDivElement | null;
}

const ControlPanelFooter: React.FC<ContainerProps> = ({
  sendThemeCommand,
  isGameLoading,
  isCallActive,
  mediaPreviewPortalNode,
}) => {
  const [isChildView, setIsChildView] = useState<boolean>(false);
  const [isInitialRender, setIsInitialRender] = useState<boolean>(true);
  const accordionRef = useRef(null);
  const [toggleValue, setToggleValue] = useState<boolean>(() => {
    // Load initial expanded state from localStorage
    const storedState = localStorage.getItem('accordion_client-preview');
    return storedState ? JSON.parse(storedState) : true; //
  });
  const { footerSx } = ControlPanelFooterSX;
  useEffect(() => {
    if (!isInitialRender) {
      sendThemeCommand(isChildView);
    } else {
      setIsInitialRender(false);
    }
  }, [isChildView]);

  const toggleView = () => {
    let canvas = document.querySelector('canvas');
    if (!canvas) return;

    let container = canvas.parentElement;
    if (!container) return;

    if (!toggleValue) {
      container.style.visibility = '';
      // @ts-ignore
      accordionRef.current.style.height = getResponsiveSize(200);
    } else {
      container.style.visibility = 'hidden';
      // @ts-ignore
      accordionRef.current.style.height = '0';
    }

    // Toggle state and update localStorage
    const newToggleValue = !toggleValue;
    setToggleValue(newToggleValue);
    localStorage.setItem('accordion_client-preview', JSON.stringify(newToggleValue)); // Update localStorage

    // Ask parent to refresh Phaser sizing only on toggle
  };

  return (
    <Box sx={footerSx} component="footer">
      <AccordionComponent
        isIcon={false}
        isClientPreview={true}
        setToggle={toggleView}
        toggleValue={toggleValue}
        title={'client-preview'}
        isExpanded={true}
      >
        <div ref={accordionRef} className="content">
          {!isGameLoading ? (
            <>
              <div id="client-task-container"></div>
              <PractitionerMediaPreviewHost portalNode={mediaPreviewPortalNode} isActive={isCallActive} isOverlay />
            </>
          ) : (
            <Box className="spinner-container">
              <CircularProgress color="inherit" />
            </Box>
          )}
        </div>
      </AccordionComponent>
    </Box>
  );
};

export default ControlPanelFooter;
